import { render, staticRenderFns } from "./ComitentesParticipantes.vue?vue&type=template&id=42c30fbe"
import script from "./ComitentesParticipantes.vue?vue&type=script&lang=js"
export * from "./ComitentesParticipantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports